module.exports = __webpack_public_path__ + "static/media/volumex.3165fc0a.svg";